import React, { useState, useEffect } from 'react'
import { socket } from '@/product/common/socket'
import moment from 'moment'

let serverTime = new Date()

const getTimeRemaining = (t) => {
    const total = Math.max(0, t)
    const seconds = Math.floor((total / 1000) % 60)
    const minutes = Math.floor((total / 1000 / 60) % 60)
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
    const days = Math.floor(total / (1000 * 60 * 60 * 24))

    return {
        total,
        days,
        hours,
        minutes,
        seconds,
    }
}

const Timer = React.memo(
    function Timer(props) {
        const [timer, setTimer] = useState({
            timervalid: false,
            timer_id: 0,
            days: 0,
            seconds: 0,
            minutes: 0,
            hours: 0,
            future: false,
        })

        const [isLastFiveMinuteEligible, setIsLastFiveMinuteEligible] = useState(false)

        const tenMinutesInMilliSeconds = 10 * 60 * 1000

        const fiveMinutesInMilliSeconds = 5 * 60 * 1000

        useEffect(() => {
            if (socket) {
                socket.on('servertime', (data) => {
                    if (moment(data.dTime).isValid()) {
                        serverTime = new Date(data.dTime)
                    }
                })

                socket.on('cartupdate', (data) => {
                    if (props?.product?.project_id === data?.id) {
                        setIsLastFiveMinuteEligible(true)
                    }
                })
            }
        }, [socket])

        const formatTimeDisplay = (timeObj, isFuture) => {
            if (isFuture) {
                // For future dates (Starts in...)
                if (timeObj.days > 0) {
                    return `Starts in ${timeObj.days} ${timeObj.days === 1 ? 'day' : 'days'} ${
                        timeObj.hours
                    } ${timeObj.hours === 1 ? 'Hour' : 'Hr'}`
                } else if (timeObj.hours > 0) {
                    return `Starts in ${timeObj.hours} ${timeObj.hours === 1 ? 'Hour' : 'Hr'} ${
                        timeObj.minutes
                    } ${timeObj.minutes === 1 ? 'Min' : 'Min'}`
                } else {
                    return `Starts in ${timeObj.minutes} ${timeObj.minutes === 1 ? 'Min' : 'Min'} ${
                        timeObj.seconds
                    } ${timeObj.seconds === 1 ? 'Sec' : 'Sec'}`
                }
            } else {
                // For ongoing timer (Time left...)
                if (timeObj.days > 0) {
                    return `${timeObj.days} ${timeObj.days === 1 ? 'day' : 'days'} ${
                        timeObj.hours
                    } ${timeObj.hours === 1 ? 'Hour' : 'Hr'}`
                } else if (timeObj.hours > 0) {
                    return `${timeObj.hours} ${timeObj.hours === 1 ? 'Hour' : 'Hr'} ${
                        timeObj.minutes
                    } ${timeObj.minutes === 1 ? 'Min' : 'Min'}`
                } else {
                    return `${timeObj.minutes} ${timeObj.minutes === 1 ? 'Min' : 'Min'} ${
                        timeObj.seconds
                    } ${timeObj.seconds === 1 ? 'Sec' : 'Sec'}`
                }
            }
        }

        useEffect(() => {
            if (
                props.date_closed &&
                moment(props.date_closed).isValid() &&
                props.date_added &&
                moment(props.date_added).isValid()
            ) {
                const interval = setInterval(() => {
                    const startDate = new Date(serverTime)
                    const endDate = new Date(props.date_closed)
                    const addDate = new Date(props.date_added)
                    let timerTime = endDate.getTime() - startDate.getTime()
                    let future = false
                    let milliSeconds = 0

                    let incrementedTime = addDate.getTime() + parseInt(milliSeconds)
                    let newaddDate = new Date(incrementedTime)

                    if (newaddDate > startDate) {
                        timerTime = incrementedTime - startDate.getTime()
                        future = true
                    }

                    const t = getTimeRemaining(timerTime)

                    if (t.total <= 0) {
                        if (!future) {
                            setTimer((prevTimer) => ({
                                ...prevTimer,
                                timer_id: interval,
                                timervalid: false,
                            }))

                            if (props.date_closed_check && props.date_closed_reached) {
                                props.date_closed_reached(true)
                            }

                            clearInterval(interval)
                        }
                    } else {
                        setTimer((prevTimer) => ({
                            ...prevTimer,
                            timer_id: interval,
                            timervalid: true,
                            days: t.days,
                            hours: t.hours,
                            minutes: t.minutes,
                            seconds: t.seconds,
                            future: future,
                        }))
                    }

                    if (props.date_closed_check) {
                        const isExpired = startDate >= endDate
                        if (isExpired && props.date_closed_reached) {
                            props.date_closed_reached(true)
                        }
                    }

                    if (props.fiveMtsTimeUpdate) {
                        if (timerTime <= fiveMinutesInMilliSeconds && isLastFiveMinuteEligible) {
                            props.fiveMtsTimeUpdate(true)
                        } else {
                            props.fiveMtsTimeUpdate(false)
                        }
                    }
                }, 1000)

                return () => clearInterval(interval)
            } else if (props.date_closed && moment(props.date_closed).isValid()) {
                let interval

                const startTimer = () => {
                    interval = setInterval(() => {
                        const startDate = new Date(serverTime)
                        const endDate = new Date(props.date_closed)
                        const timerTime = endDate.getTime() - startDate.getTime()

                        const t = getTimeRemaining(timerTime)

                        if (t.total <= 0) {
                            setTimer((prevTimer) => ({
                                ...prevTimer,
                                timer_id: interval,
                                timervalid: false,
                            }))

                            if (props.date_closed_check && props.date_closed_reached) {
                                props.date_closed_reached(true)
                            }

                            clearInterval(interval)
                        } else if (timerTime <= tenMinutesInMilliSeconds) {
                            clearInterval(interval)
                            interval = setInterval(() => {
                                const updateTimerTime =
                                    endDate.getTime() - new Date(serverTime).getTime()
                                const updateT = getTimeRemaining(updateTimerTime)

                                if (updateT.total <= 0) {
                                    clearInterval(interval)
                                    setTimer((prevTimer) => ({
                                        ...prevTimer,
                                        timer_id: interval,
                                        timervalid: false,
                                    }))
                                    if (props.date_closed_check && props.date_closed_reached) {
                                        props.date_closed_reached(true)
                                    }
                                } else {
                                    setTimer((prevTimer) => ({
                                        ...prevTimer,
                                        timer_id: interval,
                                        timervalid: true,
                                        days: updateT.days,
                                        hours: updateT.hours,
                                        minutes: updateT.minutes,
                                        seconds: updateT.seconds,
                                        future: false,
                                    }))
                                }
                            }, 1000)
                        } else {
                            setTimer((prevTimer) => ({
                                ...prevTimer,
                                timer_id: interval,
                                timervalid: true,
                                days: t.days,
                                hours: t.hours,
                                minutes: t.minutes,
                                seconds: t.seconds,
                                future: false,
                            }))
                        }
                    }, 1000)
                }
                if (props.fiveMtsTimeUpdate) {
                    const startDate = new Date(serverTime)
                    const endDate = new Date(props.date_closed)
                    const addDate = new Date(props.date_added)
                    let timerTime = endDate.getTime() - startDate.getTime()
                    if (timerTime <= tenMinutesInMilliSeconds) {
                        props.fiveMtsTimeUpdate(true)
                    } else {
                        props.fiveMtsTimeUpdate(false)
                    }
                }

                startTimer()
                return () => clearInterval(interval)
            }
        }, [props.date_closed, props.date_added, props.id])

        return (
            <>
                {timer.timer_id === 0 ? (
                    ''
                ) : timer.timervalid ? (
                    <>
                        {props.timerIcon ? <img src="/assets/svg/timer.svg" /> : null}
                        <div className="pvTimerView timer-wrap pt-1">
                            <span>{formatTimeDisplay(timer, timer.future)}</span>
                            {!timer.future && (
                                <span>{props.auction_Status ? props.auction_Status : null}</span>
                            )}
                        </div>
                    </>
                ) : (
                    'Offer Pending'
                )}
            </>
        )
    },
    (prevProps, nextProps) => {
        // Only re-render if these specific props change
        return (
            prevProps.date_closed === nextProps.date_closed &&
            prevProps.date_added === nextProps.date_added &&
            prevProps.id === nextProps.id
        )
    },
)

export default Timer
